import React, { useState, useEffect } from "react"
import { Redirect } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { KeyboardArrowDown } from "@material-ui/icons"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import { Box, FormControl, InputLabel, MenuItem, Select, TextField, Tooltip, Typography } from "@material-ui/core"
import { getCharacterCount, getUserloginDetails, setPageNumberCharCount, setPageNumberUserLoginDetails } from "../../actions/billingActions"
import { getCaseAccessList } from "../../actions/usersActions"
import { useTranslation } from "react-i18next"
import { DateRange, Reset } from "../../components/Filters"
import moment from "moment"

const useStyles = makeStyles((theme) => ({
	boxWrapper: {
		maxWidth: 150,
		minWidth: 150,
		minHeight: 48,
		maxHeight: 48,
		backgroundColor: theme.palette.common.white,
		border: `solid 1px ${theme.palette.grey.D400}`,
		borderRadius: "5px",
	},
	root: {
		flexGrow: 1,
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
	},
	select: {
		"& .MuiSvgIcon-root": {
			color: theme.palette.text.primary,
		},
		"& .MuiSelect-root": {
			...theme.typography.body1,
		},

		"& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
			border: "transparent",
		},
		"& .MuiSelect-icon.Mui-disabled": {
			opacity: "0.5",
		},
	},
	wrapper: {
		display: "flex",
		marginBottom: "20px",
	},
}))

const BillingFilters = (props) => {
	const {
		caseStatus,
		setCaseStatus,
		dateRange,
		setDateRange,
		recordsPerPageCharCount,
		recordsPerPageUserDetails,
		setRecordsPerPageCharCount,
		setRecordsPerPageUserDetails,
	} = props
	const classes = useStyles()
	const dispatch = useDispatch()
	const [t] = useTranslation("global")
	const MenuProps = {
		PaperProps: {
			style: {
				maxWidth: 216,
				maxHeight: 300,
			},
		},
		anchorOrigin: {
			vertical: "bottom",
			horizontal: "left",
		},
		getContentAnchorEl: null,
	}
	const { caseList } = useSelector((state) => state.userManagement)

	useEffect(() => {
		if (_.isEmpty(caseList)) {
			dispatch(getCaseAccessList())
		}
	}, [caseList])

	const handleCaseStatusChange = (event) => {
		dispatch(setPageNumberUserLoginDetails(1))
		dispatch(setPageNumberCharCount(1))
		setRecordsPerPageCharCount(5)
		setRecordsPerPageUserDetails(5)
		const data = {
			case_id: event.target.value?.case_id,
			start_date: dateRange?.startDate ? moment(dateRange?.startDate).format("YYYY-MM-DD") : "",
			end_date: dateRange?.endDate ? moment(dateRange?.endDate).format("YYYY-MM-DD") : "",
			return_count: 5,
			skip_count: 0,
		}
		dispatch(getCharacterCount(data))
		dispatch(getUserloginDetails({ ...data, case_id: event.target.value?.project_id, return_count: recordsPerPageUserDetails }))
		setCaseStatus(event.target.value)
	}

	const handleDateRangeChange = (value) => {
		dispatch(setPageNumberUserLoginDetails(1))
		dispatch(setPageNumberCharCount(1))
		setRecordsPerPageCharCount(5)
		setRecordsPerPageUserDetails(5)
		const data = {
			case_id: caseStatus?.case_id,
			start_date: value?.startDate ? moment(value?.startDate).format("YYYY-MM-DD") : "",
			end_date: value?.endDate ? moment(value?.endDate).format("YYYY-MM-DD") : "",
			return_count: recordsPerPageCharCount || 5,
			skip_count: 0,
		}
		dispatch(getCharacterCount(data))
		dispatch(getUserloginDetails({ ...data, case_id: caseStatus?.project_id, return_count: recordsPerPageUserDetails }))
		setDateRange(value)
	}

	const handleReset = () => {
		dispatch(setPageNumberUserLoginDetails(1))
		dispatch(setPageNumberCharCount(1))
		const data = {
			case_id: "",
			start_date: "",
			end_date: "",
			return_count: 5,
			skip_count: 0,
		}
		dispatch(getCharacterCount(data))
		dispatch(getUserloginDetails({ ...data }))
		setCaseStatus("")
		setDateRange({ startDate: "", endDate: "" })
	}

	return (
		<>
			<Grid className={classes.root} container direction="row" data-testid="all_cases_page">
				<Grid container>
					<Grid item xs={12} className={classes.wrapper}>
						<Box mr={1} className={classes.boxWrapper}>
							<FormControl fullWidth className={classes.formControl} variant="outlined" size="small">
								<Tooltip placement="top" arrow title={caseStatus?.friendly_name || ""}>
									<TextField
										variant="outlined"
										value={caseStatus || ""}
										onChange={handleCaseStatusChange}
										select
										label="Case name"
										id="case_status-select-label"
										SelectProps={{
											labelId: "case_status-select-label",
											MenuProps: MenuProps,
											IconComponent: KeyboardArrowDown,
										}}
										InputLabelProps={{ style: { fontWeight: 400 } }}
										size="small"
										className={classes.select}
										fullWidth
									>
										{caseList.map((caseName) => {
											return (
												<MenuItem key={caseName?.project_id} value={caseName}>
													{caseName?.friendly_name}
												</MenuItem>
											)
										})}
									</TextField>
								</Tooltip>
							</FormControl>
						</Box>
						<Box mr={1}>
							<DateRange
								handleDateRangeChange={handleDateRangeChange}
								dateRange={dateRange}
								setDateRange={setDateRange}
								disableFilters={false}
							/>
						</Box>
						<Box mr={1}>
							<Reset canApplyFilter={true} handleReset={handleReset} />
						</Box>
					</Grid>
				</Grid>
			</Grid>
		</>
	)
}

export default BillingFilters
